import React, { Component } from 'react';
import TableRow from './TableRow.jsx';
import { Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';

function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));;
}

const NoFilas = (props) => {
    return (<tr>
        <td colSpan="6">
            <label>A&uacute;n no existen empresas para este cliente. Por favor, cree una
                    <Link to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_NUEVA_EMPRESA") + "/0"} params={{ id: 0 }}> Nueva Empresa</Link> para continuar
            </label>
        </td>
    </tr>);
}

const EmpresaTableRow = ({ solicitudId, estadoSolicitud, row, permisos, tipoDeEmpresaId, tipoEmpresa, tipoDeEmpresa, seleccionarEmpresa, openModalInformacionEmpresa, novedad, esModificacion, hayEmpresaNueva }) => {

        let cuenta;
        let tarjeta;
        let cuentaTarjetas;
        let checked = row.seleccionada == true ? true : false;
        let disabled;
        let cantidadCuentas = Array.isArray(row.cuentas) ? row.cuentas.length : 0 ;
        let cantidadTarjetas = 0;

        Array.isArray(row.cuentas) && row.cuentas.map(cuenta=> cantidadTarjetas += cuenta.Tarjetas.length);


        cuenta = cantidadCuentas == 1 ? " cuenta con " : " cuentas con ";
        tarjeta = cantidadTarjetas == 1 ? " tarjeta " : " tarjetas ";
        cuentaTarjetas = cantidadCuentas + cuenta + cantidadTarjetas + tarjeta;

        let rowTipoEmpresaId = row.TipoEmpresaId == undefined ? tipoEmpresa.Id : row.TipoEmpresaId;

        //Una fila va a estar desactivada si...
        if (
            //EmpresaVisaTipoId es igual a 1
            (row.estado == 1) ||
            //No coincide el tipo de empresa.
            (rowTipoEmpresaId !== tipoDeEmpresaId) ||
            //Es una modificacion de una solicitud ya existente y no se encuentra seleccionada desde el primer render, por ende no es la que ya posee la solicitud desde un comienzo.
            (esModificacion == true && checked != true) ||
            //No es una empresa nueva, se entro a modificar una solicitud ya existente y no esta seleccionada de antemano, por ende no es la que ya posee la solicitud desde un comienzo.
            (row.esNueva == false && esModificacion == true && checked != true) ||
            //No es una empresa nueva pero ya hay empresas nuevas creadas y es una nueva solicitud (no es una modificacion).
            (row.esNueva == false && hayEmpresaNueva == true && esModificacion == false)) {
            disabled = true;
            
        } else {
            //Si no, esa fila estara activada.
            disabled = false;
        }
        
        //Lo mismo en una row
        //disabled = (rowTipoEmpresaId !== tipoDeEmpresaId || (checked != true && esModificacion == true) || (row.esNueva == false && esModificacion == true) || (row.esNueva == false && hayEmpresaNueva == true && esModificacion == false));
        
        return (
            <TableRow
                solicitudId={solicitudId}
                estadoSolicitud={estadoSolicitud}
                row={row}
                isVigente={row.isVigente != undefined ? row.isVigente : false}
                TipoDeEmpresa={tipoDeEmpresa}
                total={row.limiteCompraFormato}
                checked={checked}
                Disable={disabled}
                CuentasTarjetas={cuentaTarjetas}
                key={"ETPR_" + row.Id}
                permisos={permisos}
                seleccionarEmpresa={seleccionarEmpresa}
                openModalInformacionEmpresa={openModalInformacionEmpresa}
                novedad={novedad}
                esModificacion={esModificacion}
            />
        );
    }

class TableBody extends Component {
    constructor(props) {
        super(props)
    }

    render() {

        const { tarjetas, data, permisos, seleccionarEmpresa, openModalInformacionEmpresa } = this.props;
        const { empresas } = data;

        let enterpriseRowTableNodes = null;

        if (data != undefined && data != "") {
            let administradora = tarjetas.administradora.Id;
            const tipoEmpresa = tarjetas.tipoEmpresa;
            const tipoDeEmpresaId = tipoEmpresa.Id;

            let tipoDeEmpresa = tarjetas.tipoEmpresa.Descripcion;
            let novedades = tarjetas.novedadesEmpresas;
            let esModificacion = tarjetas.esModificacion;
            let solicitudId = tarjetas.id;
            let list = deepCopy(empresas);
            let estadoSolicitud = tarjetas.estadoSolicitud;

            //Obtengo si hay o no empresas nuevas.
            let pleaseTellMeIfAreNewEnterprisesInTheListOfEnteprises = (list.find(x => x.esNueva == true) != undefined);
            if (list && list.length > 0) {
                if (permisos.solicitudFunctionsAllowed.Confidencial == true) {
                    enterpriseRowTableNodes = list.map(function (row) {
                        return <EmpresaTableRow
                            solicitudId={solicitudId}
                            estadoSolicitud={estadoSolicitud}
                            row={row}
                            permisos={permisos}
                            tipoDeEmpresa={tipoDeEmpresa}
                            tipoDeEmpresaId={tipoDeEmpresaId}
                            tipoEmpresa={tipoEmpresa}
                            seleccionarEmpresa={seleccionarEmpresa}
                            openModalInformacionEmpresa={openModalInformacionEmpresa}
                            novedad={novedades.find(x => x.EmpresaId == row.Id)}
                            esModificacion={esModificacion}
                            hayEmpresaNueva={pleaseTellMeIfAreNewEnterprisesInTheListOfEnteprises}
                        />
                    });
                }
                else {
                    enterpriseRowTableNodes = list.map(function (row) {
                        if (row.EsConfidencial == false) {
                            return
                            <EmpresaTableRow
                                row={row}
                                solicitudId={solicitudId}
                                permisos={permisos}
                                tipoDeEmpresa={tipoDeEmpresaId}
                                tipoDeEmpresaId={tipoDeEmpresaId}
                                seleccionarEmpresa={seleccionarEmpresa}
                                openModalInformacionEmpresa={openModalInformacionEmpresa}
                                hayEmpresaNueva={pleaseTellMeIfAreNewEnterprisesInTheListOfEnteprises}
                            />
                        }
                        else {
                            return null;
                        }
                    });
                }

            } else {
                enterpriseRowTableNodes = <NoFilas crearNuevaCuenta={this.props.crearNuevaCuenta} />;
            }
        }

        return (
            <tbody>
                {enterpriseRowTableNodes}
            </tbody>
        );
    }
};

export default TableBody